

import React from 'react';
import { NavLink } from 'react-router-dom';
import { NavigationItemType } from '../types';

interface NavItemProps {
  item: NavigationItemType;
  isSidebarOpen: boolean;
}

export const NavItem: React.FC<NavItemProps> = ({ item, isSidebarOpen }) => {
  const IconComponent = item.icon;

  return (
    <li>
      <NavLink
        to={item.path}
        end
        className={({ isActive }) =>
          `flex items-center p-3 my-1 rounded-lg hover:bg-gray-100 dark:hover:bg-dark-tertiary transition-colors duration-200 ease-in-out
           ${isActive ? 'bg-brand-teal text-white' : 'text-gray-600 dark:text-dark-text-secondary hover:text-gray-900 dark:hover:text-dark-text-primary'}
           ${isSidebarOpen ? 'justify-start' : 'justify-center'}`
        }
        title={isSidebarOpen ? '' : item.name}
      >
        <IconComponent className={`text-2xl flex-shrink-0 ${isSidebarOpen ? 'mr-3' : ''}`} />
        {isSidebarOpen && <span className="text-sm font-medium whitespace-nowrap">{item.name}</span>}
      </NavLink>
    </li>
  );
};